module.exports = "<div class='container-fluid'>\r\n  <div class='row'>\r\n\r\n    <div class='col-sm-12 body-content'>\r\n      <router-outlet (activate)=\"onActivate($event)\" ></router-outlet>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main